"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.step-up-verification-header-class .header-class {\n  margin-top: 2rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #a8a8a8; }\n  .step-up-verification-header-class .header-class .margin-top-32 {\n    margin-top: 2rem; }\n  .step-up-verification-header-class .header-class .margin-top-8 {\n    margin-top: 0.5rem; }\n";
  var fileName = "compone_StepUpVerification";
  var element = document.querySelector("style[data-sass-component='compone_StepUpVerification']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

function StepUpVerification(_ref) {
  var _ref$policyViewData = _ref.policyViewData,
      policyViewData = _ref$policyViewData === void 0 ? {} : _ref$policyViewData,
      translatedStrings = _ref.translatedStrings,
      conditionsLabels = _ref.conditionsLabels,
      viewPolicyHeaders = _ref.viewPolicyHeaders;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.headerClass
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "pageSectionHeader"
  }, " ", viewPolicyHeaders === null || viewPolicyHeaders === void 0 ? void 0 : viewPolicyHeaders.stepUpVerification, " ")), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", conditionsLabels === null || conditionsLabels === void 0 ? void 0 : conditionsLabels.stepUpVerificationEnabled, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, (0, _get.default)(policyViewData, 'condition.stepUpCondition.factor') === 'TOTP' ? translatedStrings.yesText : translatedStrings.noText))), (0, _get.default)(policyViewData, 'condition.stepUpCondition.factor') === 'TOTP' && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", conditionsLabels === null || conditionsLabels === void 0 ? void 0 : conditionsLabels.stepUpVerificationAlwaysPrompt, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, (0, _get.default)(policyViewData, 'condition.stepUpCondition.alwaysPrompt', true) ? translatedStrings.yesText : translatedStrings.noText)))));
}

StepUpVerification.propTypes = {
  policyViewData: _propTypes.default.object,
  translatedStrings: _propTypes.default.object,
  conditionsLabels: _propTypes.default.shape({
    stepUpVerificationEnabled: _propTypes.default.string,
    stepUpVerificationAlwaysPrompt: _propTypes.default.string
  }),
  viewPolicyHeaders: _propTypes.default.shape({
    general: _propTypes.default.string,
    members: _propTypes.default.string,
    generic: _propTypes.default.string,
    approvals: _propTypes.default.string,
    stepUpVerification: _propTypes.default.string
  })
};
var _default = StepUpVerification;
exports.default = _default;